import { useMutation, useQueryClient } from '@tanstack/react-query'
import { authApi } from 'shared/api/auth'
import { GetRefreshTokensResponse } from 'shared/api/auth/requests/deviceManagement/getRefreshTokens'

export interface DeleteRefreshTokenRequest {
  id?: number
}

const deleteRefreshToken = async (data: DeleteRefreshTokenRequest) => {
  const response = await authApi.delete(
    `/refresh-tokens${data?.id ? '/' + data.id : ''}`
  )

  return { ...response.data.data, id: data?.id }
}

export const useDeleteRefreshToken = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (data: DeleteRefreshTokenRequest) => deleteRefreshToken(data),
    onSuccess: ({ id }) => {
      queryClient.setQueryData(
        ['refreshTokens'],
        (oldData?: GetRefreshTokensResponse['data']) => {
          return oldData?.filter(d => d.id !== id)
        }
      )
    }
  })

  return { mutation }
}
